import { render, staticRenderFns } from "./PcProductMain.vue?vue&type=template&id=0533bcff&scoped=true&"
import script from "./PcProductMain.vue?vue&type=script&lang=js&"
export * from "./PcProductMain.vue?vue&type=script&lang=js&"
import style0 from "./PcProductMain.vue?vue&type=style&index=0&id=0533bcff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533bcff",
  null
  
)

export default component.exports